import type { ApiError, Parcel } from "@/shared/types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { LandingState } from "./types";

/** SPEC: the landing strip shows three available parcels, never more. */
export const FEATURED_COUNT = 3;

const initialState: LandingState = {
  featured: [],
  isLoading: true,
  error: null,
};

export const landingSlice = createSlice({
  name: "landing",
  initialState,
  reducers: {
    /** Saga trigger. */
    fetchFeatured: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchFeaturedSuccess: (state, action: PayloadAction<Parcel[]>) => {
      state.featured = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    fetchFeaturedFailure: (state, action: PayloadAction<ApiError>) => {
      state.featured = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { actions: landingActions, reducer: landingReducer } =
  landingSlice;
